const LOAN_COLORS = [
  'bg-blue-500',
  'bg-indigo-500',
  'bg-purple-500',
  'bg-pink-500',
  'bg-orange-500',
  'bg-amber-500',
  'bg-teal-500',
  'bg-cyan-500',
  'bg-rose-500',
  'bg-slate-500',
] as const

export function loanColor(loanNumber: number): string {
  return LOAN_COLORS[(loanNumber - 1) % LOAN_COLORS.length]
}

export function loanLabel(loanNumber: number): string {
  return `Loan #${loanNumber}`
}

export function LoanBadge({ loanNumber, className = '' }: { loanNumber: number; className?: string }) {
  return (
    <span className={`inline-flex items-center gap-1.5 ${className}`}>
      <span className={`w-2.5 h-2.5 rounded-full inline-block shrink-0 ${loanColor(loanNumber)}`} />
      <span className="text-xs font-medium text-gray-500">{loanLabel(loanNumber)}</span>
    </span>
  )
}
